import styles from '../index.module.css'

import React from 'react'

import { HoverCard } from 'components/ds'

import type { ColoredTag } from '../utils/indicator-colors'
import { TagDot } from './tag-dot'

type Props = {
  // Every colored tag, not only the hidden ones: the card is the full legend.
  tags: ColoredTag[]
  hiddenCount: number
}

export const OverflowHoverCard = ({
  tags,
  hiddenCount,
}: Props): React.ReactElement => (
  <HoverCard.Root>
    <HoverCard.Trigger>
      {/* A button rather than a Badge so keyboard users can open the card. */}
      <button
        type="button"
        className={styles.hoverableBadge}
        aria-label={`Show all ${tags.length} indicators`}
        data-testid="indicators-overflow-badge"
      >
        +{hiddenCount}
      </button>
    </HoverCard.Trigger>
    <HoverCard.Content
      size="1"
      side="top"
      align="start"
      className={styles.tagList}
      data-testid="indicators-hover-card"
    >
      {tags.map(tag => (
        <span
          key={tag.id}
          className={styles.tagRow}
          data-testid="indicator-tag-row"
        >
          <TagDot tag={tag} showTooltip={false} />
          {tag.name}
        </span>
      ))}
    </HoverCard.Content>
  </HoverCard.Root>
)
